export default {"src":"/_next/static/media/icon-marketplace-apostle.b3456714.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};